import { FreeTrialCard } from "@/components/feature/FreeTrial/FreeTrialComposed"
import { freeTrialApplies } from "@/components/hoc/FreeTrialApplies"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { classNames } from "@/utils/classNames"
import { IconInfoCircleFilled } from "@tabler/icons-react"
import { Typography } from "../Typography/Typography"

export const InfoBoxBestUsageQuestionnaire: React.FC<InfoBoxProps> = () => {
  const { translate } = useTranslation()
  return (
    <InfoBoxCard>
      <div className="flex max-w-3xl flex-col gap-4">
        <Typography variant={"textS-bold"}>
          {translate("FREE_TRIAL/INFO/QUESTIONNAIRES/HEADER")}
        </Typography>
        <Typography variant="textXS">
          {translate("FREE_TRIAL/INFO/QUESTIONNAIRES/DESCRIPTION")}
        </Typography>
        <Typography variant={"textXS"}>
          {"👉 " + translate("FREE_TRIAL/INFO/QUESTIONNAIRES/TRICK")}
        </Typography>
      </div>
      <FreeTrialCard.QuestionnairesLimited />
    </InfoBoxCard>
  )
}

export const InfoBoxBestUsageData: React.FC<InfoBoxProps> = () => {
  const { translate } = useTranslation()
  return (
    <InfoBoxCard>
      <div className="flex max-w-3xl flex-col gap-4">
        <Typography variant={"textS-bold"}>
          {translate("FREE_TRIAL/INFO/HEADER")}
        </Typography>
        <Typography variant="textXS">
          {translate("FREE_TRIAL/INFO/DESCRIPTION")}
        </Typography>
        <ul className="list-disc">
          <li>
            <Typography variant={"textXS"}>
              {translate("FREE_TRIAL/INFO/POINT/ONE")}
            </Typography>
          </li>
          <li>
            <Typography variant={"textXS"}>
              {translate("FREE_TRIAL/INFO/POINT/TWO")}
            </Typography>
          </li>
        </ul>
        <Typography variant={"textXS"}>
          {"👉 " + translate("FREE_TRIAL/INFO/TRICK")}
        </Typography>
      </div>
      <FreeTrialCard.FilesLimited />
    </InfoBoxCard>
  )
}

interface InfoBoxProps {
  className?: string
  children?: React.ReactNode
}

export const InfoBoxCard: React.FC<InfoBoxProps> = ({
  className,
  children,
}) => {
  return (
    <div
      className={classNames(
        "flex flex-row items-start gap-4 rounded-md border border-grey3 px-S py-M",
        className,
      )}
    >
      <IconInfoCircleFilled size={24} className="self-start text-white" />
      <div className="flex w-full flex-row justify-between gap-2">
        {children}
      </div>
    </div>
  )
}

export const InfoBoxUploadDataDescription = () => {
  const { translate } = useTranslation()
  return (
    <InfoBoxCard>
      <Typography variant={"textS"}>
        {translate("KNOWLEDGEBASE/INFO_BOX_TEXT")}
      </Typography>
    </InfoBoxCard>
  )
}

const InfoBox = {
  Card: InfoBoxCard,
  BestUsage: freeTrialApplies(
    InfoBoxBestUsageData,
    InfoBoxUploadDataDescription,
  ),
  BestQuestionnaire: freeTrialApplies(InfoBoxBestUsageQuestionnaire),
}

export default InfoBox
